module.exports = __webpack_public_path__ + "static/media/gc.485be29f.png";